// extracted by mini-css-extract-plugin
export default {"root":"LazyLoader_root__VW-iJ","icon":"LazyLoader_icon__yty8f"};